import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
    static targets = ['label', 'fileInput'];

    update() {
        const file = this.fileInputTarget.files[0] || undefined;

        if (file) {
            this.labelTarget.value = file.name;
        }
    }

    clear() {
        this.labelTarget.value = null;
        this.fileInputTarget.value = null;
    }
}
